Devuelve los metadatos básicos de la organización autenticada por la credencial.

<ApiCodeExamples exampleId="metaTenant" />

<ApiResponseExamples exampleId="metaTenant" />

## Campos principales de la respuesta `200`

- `id`: ID de la organización autenticada.
- `name`: nombre visible de la organización.
- `email`: correo principal configurado para la organización.
- `is_active`: indica si la organización sigue operativamente activa.

## Cuándo usar este endpoint

- validar rápidamente qué organización autenticó la credencial;
- confirmar que la integración apunta a la organización correcta;
- ejecutar un smoke test inicial después de crear o rotar una credencial.
